export const isWX = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i)?.toString() === 'micromessenger';
};
